import { UpdateWorkStepDto, UpdateWorkStepDtoTypeEnum } from '@/api/generator';
import { WorkStep } from './types';

export function toUpdateUpdateWorkStepDto(dto: WorkStep): UpdateWorkStepDto {
  return {
    ...dto,
    $type:
      UpdateWorkStepDtoTypeEnum.PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateWorkStepDtoPtwPtw100AppZeroApplicationShared,
  };
}
